import Marquee from "react-fast-marquee";

const QUOTES = [
  { text: "The crack was never the flaw to hide. It's the seam where the gold goes.", gold: "gold" },
  { text: "Most people don't need another answer. They need to see the pattern they've been living inside.", gold: "pattern" },
  { text: "The pattern was never your enemy. Long ago, it was your protection.", gold: "protection" },
  { text: "Relationships don't create your patterns. They hold up the mirror.", gold: "mirror" },
];

const renderQuote = (q) => {
  const idx = q.text.lastIndexOf(q.gold);
  if (idx === -1) return q.text;
  return (
    <>
      {q.text.slice(0, idx)}
      <span className="text-gold">{q.gold}</span>
      {q.text.slice(idx + q.gold.length)}
    </>
  );
};

export default function QuotesStrip() {
  return (
    <section
      className="py-20 md:py-28 bg-sand/60 border-y border-[rgba(169,129,47,0.26)] overflow-hidden"
      data-testid="quotes-strip"
    >
      <Marquee speed={26} pauseOnHover gradient={false} aria-label="Signature lines">
        {QUOTES.map((q, i) => (
          <div key={i} className="flex items-center shrink-0" data-testid={`quote-item-${i}`}>
            <blockquote className="font-display italic text-goldink text-2xl md:text-4xl leading-snug px-10 md:px-16 max-w-3xl">
              "{renderQuote(q)}"
            </blockquote>
            <span className="w-2 h-2 rotate-45 bg-gold shrink-0" aria-hidden="true" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
